<div class="comments-tab-container flex-col h-full">
  <div #commentsList class="comments-list flex-col flex-1">
    @if (isLoading()) {
      <div class="skeleton-comments-list flex-col gap-16 p-16">
        <div class="skeleton skeleton-date-separator"></div>

        @for (item of [1, 2, 3]; track item) {
          <div class="skeleton-comment flex-row gap-12">
            <div class="skeleton skeleton-avatar-circle"></div>
            <div class="skeleton-comment-body flex-col gap-8">
              <div class="skeleton skeleton-text" style="width: 40%"></div>
              <div class="skeleton skeleton-message-bubble"></div>
            </div>
          </div>
        }
      </div>
    } @else if (hasError()) {
      <div class="empty-state">
        <aionz-empty-content
          title="Erro ao carregar comentários"
          description="Não foi possível buscar os comentários da solicitação. Tente recarregar a página."
          icon="error_outline">
        </aionz-empty-content>
      </div>
    } @else if (comments().length === 0) {
      <div class="empty-state">
        <aionz-empty-content
          title="Nenhum comentário"
          description="Esta solicitação ainda não possui comentários."
          icon="chat_bubble_outline">
        </aionz-empty-content>
      </div>
    } @else {
      @for (group of groupedComments(); track group.dateLabel) {
        <div class="date-separator" role="separator">
          <span class="date-separator-label">{{ group.dateLabel }}</span>
        </div>

        @for (comment of group.comments; track comment.id) {
          <div class="comment-item flex-row gap-12">
            <seed-user-avatar [size]="32" [src]="comment.user.avatarUrl" />
            <div class="comment-content flex-col gap-4">
              <div class="comment-header flex-row items-center gap-8">
                <span class="user-name">{{ comment.user.name }}</span>
              </div>
              @if (comment.attachment) {
                <aionz-card-mensagens-text
                  [type]="comment.attachment.type"
                  [content]="comment.attachment.url"
                  [fileName]="comment.attachment.fileName"
                  [fileSize]="formatFileSize(comment.attachment.fileSize)"
                  [time]="parseDate(comment.createdAt)"
                  [messageId]="comment.id + '-attachment'"
                  [isFromMe]="false">
                </aionz-card-mensagens-text>
              }
              @if (comment.text) {
                <aionz-card-mensagens-text
                  [type]="'text'"
                  [content]="comment.text"
                  [time]="parseDate(comment.createdAt)"
                  [messageId]="comment.id"
                  [isFromMe]="false">
                </aionz-card-mensagens-text>
              }
            </div>
          </div>
        }
      }
    }
  </div>

  <div class="comment-input-area">
    <input
      #fileInput
      type="file"
      class="hidden-file-input"
      [attr.accept]="fileInputAccept()"
      tabindex="-1"
      aria-hidden="true"
      (change)="onFileSelected($event)" />

    @if (attachedFile(); as file) {
      <div class="attached-file-preview flex-row items-center gap-8">
        @if (attachedFilePreviewUrl(); as previewUrl) {
          <img [src]="previewUrl" class="attached-file-thumb" alt="" />
        } @else {
          <mat-icon>insert_drive_file</mat-icon>
        }
        <span class="attached-file-name" [aionzTooltip]="file.name" mode="message">{{ file.name }}</span>
        <button
          mat-icon-button
          type="button"
          class="remove-attached-file-button"
          (click)="removeAttachedFile()"
          aria-label="Remover anexo">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }

    <div class="input-row flex-row items-center gap-12">
      <button
        mat-icon-button
        type="button"
        class="attach-button"
        [disabled]="hasError() || isSubmitting()"
        (click)="openFileOptions()"
        aria-label="Anexar arquivo">
        <mat-icon>attach_file</mat-icon>
      </button>

      <div class="input-wrapper">
        <textarea
          class="comment-textarea"
          [formControl]="commentControl"
          [disabled]="hasError()"
          placeholder="Enviar mensagem"
          rows="1"
          aria-label="Escrever comentário"
          (keydown.enter)="handleCommentKeydown($event)"
          (paste)="onPaste($event)">
        </textarea>
      </div>

      <button
        mat-fab
        class="send-button"
        [disabled]="isCommentSubmitDisabled"
        (click)="submitComment()"
        aria-label="Enviar comentário">
        @if (isSubmitting()) {
          <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <mat-icon>arrow_forward</mat-icon>
        }
      </button>
    </div>
  </div>
</div>
